import React, { useState } from 'react';

const FAQItem = ({ question, answer }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="faq-item">
      <button className="faq-question" onClick={() => setIsOpen(!isOpen)}>
        {question}
        <span className={`faq-icon ${isOpen ? 'open' : ''}`}>▼</span>
      </button>
      <div className={`faq-answer ${isOpen ? 'open' : ''}`}>
        {answer}
      </div>
    </div>
  );
};

const FAQs = () => {
  const faqs = [
    {
      question: "How long does on-boarding with Dysun take?",
      answer: "We can get Dysun up and running for your company answering user questions in 1-2 weeks."
    },
    {
      question: "Can Dysun handle complex installation scenarios?",
      answer: "Absolutely. Dysun is trained on a wide range of complex scenarios and can provide detailed, step-by-step guidance for even the most intricate installation processes."
    },
    {
      question: "Will signing up for Dysun mean my company's data is used for training AI models?",
      answer: "No, your data will be secure and never be used for training AI models."
    },
    {
    question: "How does pricing for Dysun work?",
    answer:"Contrary to existing subscription and per-seat based solutions, Dysun is a pay-for-outcome solution. You will only be charged for outcomes - i.e. number of issues resolved."
    }
    // Add more FAQs as needed
  ];

  return (
    <section className="faqs" id="faqs">
      <h2>FAQs</h2>
      <div className="faq-list">
        {faqs.map((faq, index) => (
          <FAQItem key={index} question={faq.question} answer={faq.answer} />
        ))}
      </div>
    </section>
  );
};

export default FAQs;